import { createContext } from 'react';
import {ID, Response} from '../../../../../_dashboard/helpers'

export interface Contact {
  email: string;
  phone:string;
  adress:string;
  description?:string;
}


export const initialContact: Contact = {

  
    email: '',
    phone: '',
    adress:'',
  description:'',

};
export type ContactQueryResponse = Response<Array<Contact>>;
export type QueryResponseContactContextProps<T> = {
  dataResponse?: Response<Array<T>> | undefined
  refetchData: () => void
  isLoading: boolean
  query: any
}
export function createContactResponseContext<T>(initialState: QueryResponseContactContextProps<T>) {
  return createContext(initialState)
}
export const initialContactQueryResponse = { refetchData: () => { }, isLoading: false, query: '' }